import { InjectionToken } from '@angular/core';
import { LoggerConfig, LoggerHttpSender } from './logger.types';

export const LOGGER_CONFIG = new InjectionToken<LoggerConfig>('LOGGER_CONFIG');
export const LOGGER_HTTP_SENDER = new InjectionToken<LoggerHttpSender>('LOGGER_HTTP_SENDER');
